/**
* The public-facing redirect functionality of the login.
*
* @since      1.0.0
*
* @package    U4SM-adaptor
* @subpackage U4SM-adaptor/public/js
*/
(function (jQuery, undefined) {

    var sm = window.sm = window.sm || {},
        extend = jQuery.extend,
        each = jQuery.each,
        proxy = jQuery.proxy,
        noop = jQuery.noop,
        isFunction = jQuery.isFunction,
        globalize = window.Globalize;

    if (typeof sm.portal === "undefined") {
        extend(sm, { portal: {} });
    }
    if (typeof sm.portal.plugin === "undefined") {
        extend(sm.portal, { plugin: {} });
    }
    if (typeof sm.portal.plugin.public === "undefined") {
        extend(sm.portal.plugin, { public: {} });
    }

    jQuery(document).ready(function () {
        sm.portal.plugin.public.toggleSMHeaderLogin();
        sm.portal.plugin.public.errorLightbox();
    });

    function toggleSMHeaderLogin() {
        var that = jQuery('.smHeaderLogin button');
        var myMenu = jQuery('.sm_loginWidget').first();
        var title = that.attr('data-lightbox-title');

        that.not('[data-processed="true"]').on('click', function () {
            sm.portal.ui.lightBox(title, myMenu, 'sm_loginDialog');
            // focus username field - sucks on ipad - disabling till i get better mobile detection in place
            //if (!jQuery('body').hasClass('ipad') || !jQuery('body').hasClass('iphone')) {
            //    jQuery('.smModal .sm_loginFields input[type="text"]').focus();
            //}
        });
        that.attr('data-processed', true);
    }

    function errorLightbox() {
        var errMsg = jQuery('.sm_loginErrorMessage');
        var title = errMsg.attr('data-lightbox-title');
        var content = errMsg.html();

        if (errMsg.length > 0) {
            sm.portal.ui.lightBox(title, content, 'sm_loginDialog error');
            errMsg.remove();
        }
    }

    function show_lightbox_error(title, content, displayclass, callback) {

        if (displayclass == null || displayclass == '') {
            displayclass = 'sm_loginDialog error';
        }
        sm.portal.ui.lightBox(title, content, displayclass, callback);
    }

    // theAction = string
    // theObj = any object
    // theSuccessFunc = function
    // theFailFunc = function 
    function php_ajax(theAction, theObj, theSuccessFunc, theFailFunc) {

        jQuery.post(
            ajax_object.ajax_url, // object was declared in the "redirect_scripts" in the php file
                {
                    // here we declare the parameters to send along with the request
                    // this means the following action hooks will be fired
                    // (assuming the action was "save_options"):
                    // wp_ajax_nopriv_save_options and wp_ajax_save_options
                    action: theAction,

                    // other parameters can be added along with "action"
                    result: theObj
                },
                function (res, code, xhr) {
                    if (code == 'success') {
                        eval(theSuccessFunc(res));
                    }
                }
            ).fail(function (xhr, status, error) {
                eval(theFailFunc(error));
            });
    }

    jQuery.extend(true, sm.portal.plugin.public, {
        toggleSMHeaderLogin: toggleSMHeaderLogin,
        errorLightbox: errorLightbox, 
        show_lightbox_error: show_lightbox_error, 
        php_ajax: php_ajax,
    });
})(jQuery);